// Icon mapping for menu items
import {
  Server,
  Network,
  Shield,
  FileKey,
  Link2,
  Tag,
  Database,
  HardDrive,
  Wifi,
  Camera,
  Globe,
  Building2,
  BatteryCharging,
  Battery,
  Smartphone,
  Monitor,
  Printer,
  Projector,
  Clock,
  Tv,
  Tablet,
  Phone,
  MapPin,
  Warehouse,
  CircleDot,
  Box,
  Users,
  UserCog,
  Palette,
  AppWindow,
  Layers,
  AlertTriangle,
  Cloud,
  Timer,
  Plug,
  GitBranch,
  Cpu,
  Truck,
  Wrench,
  Bot,
} from 'lucide-react';

export const iconMap = {
  // Assets
  'Servidores': Server,
  'Switches': Network,
  'Firewalls': Shield,
  'Certificados': FileKey,
  'Enlaces': Link2,
  'Licencias': Tag,
  'Motores SQL': Database,
  'NAS': HardDrive,
  'Access Points': Wifi,
  'Cámaras': Camera,
  'IoT': Globe,
  'Tenants Cloud': Cloud,
  'UPS': BatteryCharging,
  'Workstations': Monitor,
  // Virtualización
  'Plataformas': Server,
  'Máquinas Virtuales': Monitor,
  'Datastores': HardDrive,
  'Hosts Hyper-V': Server,
  'VMs Hyper-V': Monitor,
  'Storage Hyper-V': HardDrive,
  'Discos VHD': HardDrive,
  // Apps
  'Inventario': AppWindow,
  'Mapa Visual': GitBranch,
  'Interfaces': Link2,
  'Tipos App': AppWindow,
  'Estados App': CircleDot,
  'Roles Responsable': Users,
  'Tipos Interfaz': Plug,
  'Tipos BD': Database,
  // Micro
  'Celulares': Smartphone,
  'Computadoras': Monitor,
  'Impresoras': Printer,
  'Monitores': Monitor,
  'Proyectores': Projector,
  'Relojes': Clock,
  'Televisores': Tv,
  'Tablets': Tablet,
  'Teléfonos IP': Phone,
  // Config - Organización
  'Empresas': Building2,
  'Sites': MapPin,
  'Ubicaciones': Warehouse,
  // Config - Clasificación
  'Estados': CircleDot,
  'Criticidad': AlertTriangle,
  'Tipos Dispositivo': Box,
  'Tipos Vencimiento': Clock,
  // Config - Infraestructura
  'Ambientes': Layers,
  'Cloud': Cloud,
  'Sistemas Operativos': Monitor,
  'Ventanas Reinicio': Timer,
  // Config - Redes
  'Tipos Conexion': Plug,
  'Tipos Enlace': Link2,
  'Roles Enlace': GitBranch,
  'Modelos Firewalls': Shield,
  'Modelos Access Points': Wifi,
  // Config - Equipamiento
  'DVR / NVR': HardDrive,
  'Marcas': Tag,
  'Modelos Switches': Cpu,
  'Modelos UPS': Battery,
  // Config - Terceros
  'Proveedores': Truck,
  // Config - Sistema
  'Catálogo KB': Wrench,
  'Políticas de Backup': Database,
  'Cobertura de backups': Database,
  'Estado Agentes': Monitor,
  // Config - Licencias
  'Tipos Licencia': Tag,
  'Tipos Vencimiento Lic.': Clock,
  'Tiempos Alerta': AlertTriangle,
  // Config - IoT
  'Tipos IoT': Cpu,
  // Config - Storage
  'Tipos Storage': HardDrive,
  // Config - DNS
  'DNS': Globe,
  // Config - Otros
  'Tema': Palette,
  // IPAM
  'L2 Domains': Network,
  'VLANs': Layers,
  'Subnets': Network,
  'Direcciones IP': Wifi,
  // Admin
  'Ibi': Bot,
  'Usuarios': Users,
  'Roles': UserCog,
};
